export enum DashboardTabTypes {
	workForce = 'workForce',
	activities = 'activities',
	issues = 'issues',
	safetyEvents = 'safetyEvents',
}
